// WHY: the embed builds `https://${host}/js/builder.js`, so a host carrying a scheme 404s the script.
export const toEmbedHost = (docusealHost)=>docusealHost.replace(/^https?:\/\//, '');
